<template>
	<div class="flow-countdown-wrapper">
		<div v-if="showLabel && remaining > 0" class="flow-countdown-label">
			<Typography type="p1" weight="medium" color="dark"> {{ remaining }}s </Typography>
		</div>
		<div v-if="remaining > 0" class="flow-countdown-circle" :style="circle">
			<div class="flow-countdown-pie flow-countdown-spinner" :style="spinner" />
			<div class="flow-countdown-pie flow-countdown-filler" :style="filler" />
			<div class="mask" :style="mask" />
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";
import Typography from "./../Typography/Typography.vue";

export default defineComponent({
	name: "Countdown",
	components: { Typography },
	props: {
		/**
		 * Display remaining seconds <br/>
		 * true | false
		 */
		showLabel: {
			type: Boolean,
			default: true
		},
		/**
		 * Number in seconds
		 */
		duration: {
			type: Number,
			default: 5
		},
		/**
		 * Number in px
		 */
		size: {
			type: Number,
			default: 24
		},
		/**
		 * color of circle
		 */
		color: {
			type: String,
			default: "var(--dashboard-primary)"
		},
		/**
		 * background color
		 *
		 */
		background: {
			type: String,
			default: "var(--dashboard-background)"
		}
	},
	data() {
		return {
			remaining: 0
		};
	},
	computed: {
		circle() {
			return {
				backgroundColor: this.color,
				width: `${this.size}px`,
				height: `${this.size}px`
			};
		},
		spinner() {
			return {
				background: this.background,
				animationDuration: `${this.duration}s`
			};
		},
		filler() {
			return {
				background: this.background,
				animationDuration: `${this.duration}s`
			};
		},
		mask() {
			return {
				animationDuration: `${this.duration}s`
			};
		}
	},
	mounted() {
		this.init();
	},
	methods: {
		init() {
			this.remaining = this.duration;
			this.intervalRef = setInterval(() => {
				this.remaining -= 1;
				if (this.remaining === 0) {
					this.remaining = this.duration;
				}
			}, 1000);
		}
	}
});
</script>
<style lang="scss">
div.flow-countdown-wrapper {
	display: inline-flex;

	div.flow-countdown-circle {
		position: relative;
		margin-left: 8px;
		clip-path: circle(49%);
		transform: rotate(180deg);
		transform-origin: center;
	}
	.flow-countdown-label {
		min-width: 32px;
		display: inline-flex;
		justify-content: flex-end;
		align-items: center;
	}
}

@mixin timer($duration, $item: ".flow-countdown-circle", $border: none, $hover: running) {
	#{$item},
	#{$item} * {
		box-sizing: border-box;
	}

	#{$item} .flow-countdown-pie {
		width: 50%;
		height: 100%;
		transform-origin: 100% 50%;
		position: absolute;
		border: #{$border};
	}

	#{$item} .flow-countdown-spinner {
		border-radius: 100% 0 0 100% / 50% 0 0 50%;
		z-index: 2;
		border-right: none;
		animation-name: rota;
		animation-timing-function: linear;
		animation-iteration-count: infinite;
	}

	#{$item}:hover .flow-countdown-spinner,
	#{$item}:hover .flow-countdown-filler,
	#{$item}:hover .mask {
		animation-play-state: $hover;
	}

	#{$item} .flow-countdown-filler {
		border-radius: 0 100% 100% 0 / 0 50% 50% 0;
		left: 50%;
		opacity: 0;
		z-index: 1;
		border-left: none;
		animation-name: opa;
		animation-timing-function: steps(1, end);
		animation-iteration-count: infinite;
		animation-direction: reverse;
	}

	#{$item} .mask {
		width: 50%;
		height: 100%;
		position: absolute;
		background: inherit;
		opacity: 1;
		z-index: 3;
		animation-name: opa;
		animation-timing-function: steps(1, end);
		animation-iteration-count: infinite;
	}

	@keyframes rota {
		0% {
			transform: rotate(360deg);
		}
		100% {
			transform: rotate(0deg);
		}
	}

	@keyframes opa {
		0% {
			opacity: 1;
		}
		50%,
		100% {
			opacity: 0;
		}
	}
}

@include timer(5);
</style>
